import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface PromptPasswordModalState {
    isVisible: boolean;
    message?: string;
}

export default makeReducer<PromptPasswordModalState>(
    [
        match(Actions.askForPassword, (state, {payload}) => ({
            isVisible: true,
            message: payload.message,
        })),
        match(Actions.askForPasswordSuccess, state => ({...state, isVisible: false})),
        match(Actions.askForPasswordFailed, state => ({...state, isVisible: false})),
    ],
    {
        isVisible: false,
    },
);
